<template>
  <div
    v-if="isGetConfig"
    class="category-page"
    :style="themeStyle"
  >
    <template-header
      ref="header"
      :config-data="configData.style"
    />

    <div
      ref="content"
      class="board"
      :style="{ margin: configData.style.board.useboard ? 0 : 'none' }"
    >
      <div
        v-if="configData.style.board.useboard"
        class="top"
      >
        <template-image
          v-if="configData.style.board.top && configData.style.board.top.image"
          :image-data="configData.style.board.top"
          :max-width="'1400px'"
        />
        <template-empty-area
          v-else
          :area-name="'上邊框（建議寬度:1400px）'"
          class="w-100"
          style="max-width: 1400px;"
        />
      </div>
      <category-list :config-data="configData" />
      <div
        v-if="configData.style.board.useboard"
        class="bottom"
        :style="{
          marginBottom: configData.style.footer.useImageFooter ? '0' : '2rem',
        }"
      >
        <template-image
          v-if="configData.style.board.bottom && configData.style.board.bottom.image"
          :image-data="configData.style.board.bottom"
          :max-width="'1400px'"
        />
        <template-empty-area
          v-else
          :area-name="'下邊框（建議寬度:1400px）'"
          class="w-100"
          style="max-width: 1400px;"
        />
      </div>
    </div>

    <template-footer
      ref="footer"
      :config-data="configData.style.footer"
      :ad-data="adConfig"
    />
    <search-view
      :use-navbar="configData.style.base.useNavbar"
      :theme-style="configData.style.base.config"
      :footer-display="footerDisplay"
    />

    <div
      v-if="configData.style.base.advertise && configData.style.base.advertise.show"
      class="advertise left d-none d-md-block"
    >
      <template-button :btn-config="configData.style.base.advertise" />
      <div class="close-btn">
        <button @click="configData.style.base.advertise.show = false">
          <svg
            clip-rule="evenodd"
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m21 3.998c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm7.491 6.432 2.717-2.718c.146-.146.338-.219.53-.219.404 0 .751.325.751.75 0 .193-.073.384-.22.531l-2.717 2.717 2.728 2.728c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-2.728-2.728-2.728 2.728c-.147.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l2.728-2.728-2.722-2.722c-.146-.147-.219-.338-.219-.531 0-.425.346-.749.75-.749.192 0 .384.073.53.219z"
              fill-rule="nonzero"
            />
          </svg>
          關閉
        </button>
      </div>
    </div>
    <div
      v-if="configData.style.base.advertise2 && configData.style.base.advertise2.show"
      class="advertise right d-none d-md-block"
    >
      <template-button :btn-config="configData.style.base.advertise2" />
      <div class="close-btn">
        <button @click="configData.style.base.advertise2.show = false">
          <svg
            clip-rule="evenodd"
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m21 3.998c0-.478-.379-1-1-1h-16c-.62 0-1 .519-1 1v16c0 .621.52 1 1 1h16c.478 0 1-.379 1-1zm-16.5.5h15v15h-15zm7.491 6.432 2.717-2.718c.146-.146.338-.219.53-.219.404 0 .751.325.751.75 0 .193-.073.384-.22.531l-2.717 2.717 2.728 2.728c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-2.728-2.728-2.728 2.728c-.147.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l2.728-2.728-2.722-2.722c-.146-.147-.219-.338-.219-.531 0-.425.346-.749.75-.749.192 0 .384.073.53.219z"
              fill-rule="nonzero"
            />
          </svg>
          關閉
        </button>
      </div>
    </div>

    <copy-right v-if="isGetConfig && footerDisplay" />
  </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'

import CategoryList from './CategoryList.vue'
import TemplateHeader from '../component/TemplateHeader.vue'
import TemplateFooter from '../component/TemplateFooter.vue'
import TemplateImage from '../component/TemplateImage.vue'
import TemplateButton from '../component/TemplateButton.vue'
import TemplateEmptyArea from '../component/TemplateEmptyArea.vue'
import searchView from '../component/SearchView.vue'
import CopyRight from '../component/CopyRightFooter.vue'

import {
  socketChangeRouter,
} from '@/auth/utils'
import store from '@/store'
import useStoreModule from './useStoreModule'

export default {
  components: {
    CategoryList,
    TemplateHeader,
    TemplateImage,
    TemplateButton,
    TemplateFooter,
    TemplateEmptyArea,
    searchView,
    CopyRight,
  },
  data() {
    return {
      themeStyle: null,
    }
  },
  computed: {
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  watch: {
    isGetConfig(value) {
      if (value) {
        document.title = this.configData.server_name ? `公告列表 | ${this.configData.server_name}` : '公告列表'
        this.handleResize()
        socketChangeRouter()
      }
    },
  },
  created() {
    // 在组件创建时添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 在组件销毁之前移除事件监听器，以防止内存泄漏
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    handleResize() {
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      const backgroundConfig = {}
      backgroundConfig.backgroundColor = this.configData.style.base.config['--background-color'] ? this.configData.style.base.config['--background-color'] : 'transparent'
      if (windowWidth > 991) {
        const backgroundImage = this.configData.style.base.background.image ? this.configData.style.base.background.image : this.configData.style.base.backgroundsm.image
        if (backgroundImage) {
          backgroundConfig.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.style.base.background.image) : this.configData.style.base.background.image}`
        }
      } else {
        const backgroundImage = this.configData.style.base.backgroundsm.image ? this.configData.style.base.backgroundsm.image : this.configData.style.base.background.image
        if (backgroundImage) {
          backgroundConfig.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(backgroundImage) : backgroundImage}`
        }
      }
      this.themeStyle = [
        this.configData.style.base.config,
        this.configData.style.board.config,
        backgroundConfig,
      ]
      this.$nextTick(() => {
        const headerHeight = this.$refs.header.$el.clientHeight
        const contentHeight = this.$refs.content.clientHeight
        const footerHeight = this.$refs.footer.$el.clientHeight
        const windowSpace = windowHeight - (headerHeight + footerHeight + contentHeight)
        if (windowSpace > 0) {
          this.$refs.footer.$el.style.marginTop = `${windowSpace}px`
        } else {
          this.$refs.footer.$el.style.marginTop = 0
        }
      })
    },
  },
  setup() {
    // 模組註冊
    const HOME_ADMIN_STORE_MODULE_NAME = 'category'

    if (!store.hasModule(HOME_ADMIN_STORE_MODULE_NAME)) store.registerModule(HOME_ADMIN_STORE_MODULE_NAME, useStoreModule)

    onUnmounted(() => {
      if (store.hasModule(HOME_ADMIN_STORE_MODULE_NAME)) store.unregisterModule(HOME_ADMIN_STORE_MODULE_NAME)
    })

    const isGetConfig = ref(false)
    const adConfig = ref(null)
    const configData = ref(null)
    const baseUrl = ref('')
    const footerDisplay = ref(true)

    const getAdConfig = () => {
      store.dispatch('category/getAdConfig')
        .then(localResponse => {
          adConfig.value = localResponse.data
        })
    }

    const getLocalConfig = () => {
      store.dispatch('category/getLocalConfig')
        .then(localResponse => {
          configData.value.style = localResponse.data
          isGetConfig.value = true
        })
    }
    const getCategoryConfig = () => {
      store.dispatch('category/getCategoryConfig')
        .then(response => {
          configData.value = response.data.data
          baseUrl.value = response.data.data.base_url
          if (response.data.data.support_url) store.dispatch('api/loadTawkToScript', response.data.data.support_url)
          if (response.data.data.footer_display !== undefined && response.data.data.footer_display === false) footerDisplay.value = false
          store.commit('api/UPDATE_BASE_URL', baseUrl.value)
          if (configData.value && configData.value.style) isGetConfig.value = true
          else getLocalConfig()
        })
        .catch(() => {
          getLocalConfig()
        })
    }
    getAdConfig()
    getCategoryConfig()
    // getLocalConfig()

    return {
      baseUrl,
      footerDisplay,
      adConfig,
      configData,
      isGetConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
$background-color: var(--background-color);
$background-style: var(--background-style);
$background-style-sm: var(--background-style-sm);
$background-attachment: var(--background-attachment);
$background-attachment-sm: var(--background-attachment-sm);
$text-color: var(--text-color);

.category-page {
  position: relative;
  background-repeat: no-repeat;
  background-position: top;
  background-size: $background-style;
  background-attachment: $background-attachment;
  background-color: $background-color;
  min-height: 100vh;
  @media screen and (max-width: 991px) {
    background-size: $background-style-sm;
    background-attachment: $background-attachment-sm;
  }
}

.top {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: calc(var(--header-margin)  * -1vw);
}
.bottom {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: calc(var(--bottom-margin)  * -1vw);
}
.board {
  position: relative;
  z-index: 0;
  // width: 100%;
  padding: 0px;
}
.advertise {
  position: fixed;
  z-index: 100;
  bottom: 30vh;
  &.left {
    left: 0;
    .close-btn {
      justify-content: flex-start;
    }
  }
  &.right {
    right: 0;
    .close-btn {
      justify-content: flex-end;
    }
  }
  .close-btn {
    display: flex;
    button {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: $text-color;
      border: none;
      background-color: transparent;
      transition: .3s;
      &:hover {
        transform: scale(1.2);
      }
    }
    svg {
      fill: $text-color;
      width: 16px;
      height: 16px;
    }
  }
}
</style>
